import React from 'react'
import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { realTimeTasks, userComesFromUrl } from './@signals'

import { formatPercentage, isEmpty } from '@ui-seeker/utils'
import { dsColorNew } from "@palette"


// A compact card above the results: status icon and percentage, the bar, then done/total; app blue while it searches, green when done
export default function RealTimeLinearProgress() {
	if(isEmpty(realTimeTasks.value)) return null

	const actual = realTimeTasks.value?.numTasks
	const total = realTimeTasks.value?.completeTasks
	if (actual === null) return null

	const percentage = (actual * 100) / total
	const finish = actual >= total

	return <Box sx={{
		display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.25,
		backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '12px',
	}}>
		{finish
			? <IconSeeker icon="circle-check" sx={{ fontSize: 15, color: dsColorNew.successBar }}/>
			: <CircularProgress size={14} thickness={5} sx={{ color: dsColorNew.appBlue }}/>}
		{!isNaN(percentage) && <Typography sx={{ fontSize: 13, fontWeight: 600, color: dsColorNew.textTitle, minWidth: 40 }}>
			{formatPercentage(percentage)}
		</Typography>}
		<LinearProgress
			variant="determinate"
			value={isNaN(percentage) ? 0 : percentage}
			sx={{
				flex: 1, height: 6, borderRadius: 3,
				'& .MuiLinearProgress-bar': { borderRadius: 3, backgroundColor: finish ? dsColorNew.successBar : dsColorNew.appBlue },
			}}
		/>
		<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted, whiteSpace: 'nowrap' }}>{actual}/{total}</Typography>
	</Box>
}
